import cn from 'classnames'
import React from 'react'

import { NavigationItemVariant } from '../../lib/types'
import styles from './NavigationItem.module.scss'

interface NavigationItemButtonProps extends React.HTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode
  before?: React.ReactNode
  after?: React.ReactNode
  selected?: boolean
  hovered?: boolean
  disabled?: boolean
  variant?: NavigationItemVariant
}

function NavigationItemButton(
  {
    children,
    before,
    after,
    selected,
    hovered,
    variant = 'default',
    disabled,
    className,
    ...props
  }: NavigationItemButtonProps,
  ref: React.ForwardedRef<HTMLButtonElement>
) {
  return (
    <button
      ref={ref}
      type="button"
      disabled={disabled}
      className={cn(
        styles.itemButton,
        variant && styles[variant],
        selected && styles.selected,
        hovered && styles.hovered,
        disabled && styles.disabled,
        className
      )}
      {...props}
    >
      {before && <span className={styles.before}>{before}</span>}
      {children && <span className={styles.content}>{children}</span>}
      {after && <span className={styles.after}>{after}</span>}
    </button>
  )
}

export default React.forwardRef<HTMLButtonElement, NavigationItemButtonProps>(NavigationItemButton)
